<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-icon>check</v-icon> Aprobar uso de vacación
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="py-0 px-3">
          <v-container class="p-0" grid-list-md style="min-width: 100%;">
            <v-layout wrap>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Número:</strong> {{ this.form.numero }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Nombre:</strong>
                  {{ this.form.nombres }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Cedula:</strong>
                  {{ this.form.nro_doc }}
                </h4>
              </v-flex>

              <v-flex xs12>
                <h4 class="subtitulo-uso">
                  <strong>{{ subtitulo_detalle }}</strong>
                </h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light"
                  :items="lista_papeleta"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>
                    <td class="text-xs-center">{{ props.item.dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <h4 class="subtitulo-uso">
                <strong>{{ subtitulo_seguimiento }}</strong>
              </h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light"
                  :items="lista_detalle"
                  hide-actions
                  :headers="headers2"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.usuario }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="rgba(14, 187, 178, 0.6)" @click.prevent="aprobarUso()"
            ><v-icon>done</v-icon>
            Aprobar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,

      form: {
        funcionario: {
          nombre: ""
        }
      },
      //url: 'vCronoVacass',
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      subtitulo_detalle: "Detalle de vacación programada",
      subtitulo_seguimiento: "Seguimiento de vacación programada",
      lista_papeleta: [],
      lista_detalle: [],
      headers: [
        { text: "Fecha salida", sortable: false, align: "center" },
        { text: "Fecha fin", sortable: false, align: "center" },

        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" }
      ],
      headers2: [
        { text: "Fecha registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario", sortable: false, align: "center" },
        { text: "Solicitud enviada a:", sortable: false, align: "center" }
      ]
    };
  },
  async mounted() {
    this.$bus.$on("openDialogAprobarUsoJefeInmediato", async item => {
      this.form = item;
      if (this.form.tipo == "FR") {
        await this.cargarReprogramaciones();
        this.titulo = "Ver reprogramación de vacaciones";
        this.subtitulo_detalle =
          "Detalle de vacación programada a ser reprogramada";
        this.subtitulo_seguimiento =
          "Seguimiento de reprogramación de vacación";
      }
      if (this.form.tipo == "R") {
        await this.cargarReprogramaciones();
        this.titulo = "Ver reprogramación de vacación";
        this.subtitulo_detalle = "Detalle de vacación reprogramada";
        this.subtitulo_seguimiento = "Seguimiento de vacación reprogramada";
      }
      this.form.id = parseInt(this.form.id);
      this.cargarTablaPapeleta();
      this.dialog = true;
      await this.cargarSeguimiento();
    });
  },

  methods: {
    close() {
      this.form = {
        funcionario: {
          nombre: ""
        }
      };
      this.lista_papeleta = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogAprobarUsoJefeInmediato");
      this.dialog = false;
    },
    cargarTablaPapeleta() {
      const elemento = {
        fecha_desde: this.form.fecha_desde,
        fecha_hasta: this.form.fecha_hasta,
        dias: this.form.dias,
        estado: this.form.estado
      };
      this.lista_papeleta.push(elemento);
    },
    async cargarReprogramaciones() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
              query{
                  runQuery(consulta:"select * from vacaciones.v_vacaciones_reprogramadas vsvp where vsvp.id_padre =${this.form.id_vacacion}"){
                      respuesta
                  }
                  }
              `
        });

        if (respuesta.runQuery.respuesta.length > 0) {
          respuesta = respuesta.runQuery.respuesta;
          this.lista_reprogramaciones = respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async cargarSeguimiento() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			query{
				runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra =${parseInt(
          this.form.id_vacacion
        )}"){
					respuesta
				}
				}
			`
        });
        respuesta = respuesta.runQuery.respuesta;
        let lista_seguimiento = [];
        if (this.form.tipo == "P") {
          respuesta.forEach(element => {
            let elemento = element;
            if (
              elemento.id_estado != 22 &&
              elemento.id_estado != 54 &&
              elemento.id_estado != 51 &&
              elemento.id_estado != 66 &&
              elemento.id_estado != 74 &&
              elemento.id_estado != 73 &&
              elemento.id_estado != 72
            ) {
              lista_seguimiento.push(elemento);
            }
          });
          this.lista_detalle = lista_seguimiento;
        } else {
          this.lista_detalle = respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async aprobarUso() {
      let respuesta;
      let resps = [];
      let correcto;
      let user = this.$storage.get("user");
      let id_funcionario = user.id;
      this.form.motivo = "0 motivo";

      this.loading = true;
      try {
        respuesta = await this.$service.graphql({
          query: `
									 query{
                                      runQuery(consulta:"select vacaciones.fn_aprobar_uso_vacacion_programada(${this.form.id_vacacion},58,${user.id})"){
                                        respuesta
                                      }
                                    }
								`
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_aprobar_uso_vacacion_programada;
        resps = respuesta.split("|");
        correcto = resps[0];

        if (correcto === "1") {
          this.$alert(
            "La solicitud de uso fué enviada al superior jerarquico",
            () => {
              this.loading = false;
              this.close();
            }
          );
        } else {
          this.$alert(resps[1], () => {
            this.loading = false;
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.titulo {
  font-size: 1.07em;
  color: rgb(0, 77, 128);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(0, 50, 83);
}
.subtitulo-uso {
  font-size: 1.35em;
  color: rgb(0, 77, 128);
  font-weight: bolder;
}
.cabecera {
  background-color: rgba(20, 7, 84, 0.35);
  font-size: 1.5em;
  color: rgba(20, 7, 84);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/dialogs/AprobarUsoJefeInmediato.vue